export default __webpack_public_path__ + "static/media/acae_user.49829f5b.svg";